/**
 * Flag values captured the first time each lander is seen. Anonymous visitors share one LD key and have no
 * country_code; after sign up the context is identified (firebaseUid + country_code), so a percentage rollout
 * or a country_code rule could flip the flag mid-flow and mix old and new steps. Pinning the first value keeps
 * the whole flow on one side. It lives for the page session; a reload re-evaluates.
 *
 * Kept free of imports so the analytics service can read it without a dependency cycle.
 */
export const pinnedFlags: { su?: boolean; em?: boolean; reg?: boolean; regCountrySelection?: boolean } = {};

/** Test helper: forget the pinned flag values. */
export function resetPinnedNewLanderFlags() {
  delete pinnedFlags.su;
  delete pinnedFlags.em;
  delete pinnedFlags.reg;
  delete pinnedFlags.regCountrySelection;
}

const LANDERS = [
  { landing: 'direct_su', pin: 'su' },
  { landing: 'direct_em', pin: 'em' },
  { landing: 'direct_reg', pin: 'reg' },
] as const;

/**
 * The lander (`direct_su`, `direct_em` or `direct_reg`) whose redesigned sign up is running in this page session.
 * The `landing` param decides while it is in the URL; it is cleared when the sign up closes, so the pins cover the
 * rest of the flow (welcome bonus, country select).
 */
export function getNewLanderType(): string | undefined {
  const landing = new URLSearchParams(window.location.search).get('landing');
  const inUrl = LANDERS.find((lander) => lander.landing === landing);

  // A lander in the URL decides: one with its flag off must not be reported as another pinned lander.
  if (inUrl) {
    return pinnedFlags[inUrl.pin] ? inUrl.landing : undefined;
  }

  return LANDERS.find((lander) => pinnedFlags[lander.pin])?.landing;
}
